var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-bar-header"},[_c('div',{staticClass:"nav-bar-center"},[_vm._v(" 企业总数： "),_c('span',{staticStyle:{"color":"#007ef2"}},[_vm._v(_vm._s(_vm.totalCompany || "0")+" 家")]),_vm._v("         |           "),_vm._v(" 累计访问量： "),_c('span',{staticStyle:{"color":"#007ef2"}},[_vm._v(_vm._s(_vm.displayTotalView || "0")+" 人")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }